import React from "react";
import { IoArrowUpOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

const companyLinks = [{ label: "Our story", to: "/about" }, { label: "Shop all", to: "/shop" }, { label: "Contact", to: "/contact" }];
const customerCareLinks = [{ label: "Shipping", to: "/shipping" }, { label: "Returns", to: "/returns" }, { label: "FAQs", to: "/faqs" }, { label: "Privacy", to: "/privacy" }, { label: "Cookie policy", to: "/cookies" }, { label: "Terms", to: "/terms" }];

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return <footer className="site-footer" role="contentinfo">
    <div className="site-footer__information">
      <div className="site-footer__introduction">
        <Link className="site-footer__mini-wordmark" to="/" aria-label={siteConfig.logo.ariaLabel}>{siteConfig.logo.text}</Link>
        <p>{siteConfig.description}</p>
        <span>{siteConfig.contact.address} · {siteConfig.contact.email}</span>
      </div>
      <nav className="site-footer__link-group" aria-label="Company"><h3>Company</h3>{companyLinks.map((link) => <Link key={link.label} to={link.to}>{link.label}</Link>)}</nav>
      <nav className="site-footer__link-group" aria-label="Customer care"><h3>Customer care</h3>{customerCareLinks.map((link) => <Link key={link.label} to={link.to}>{link.label}</Link>)}</nav>
      <div className="site-footer__link-group"><h3>Contact</h3><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a><p>{siteConfig.contact.address}</p></div>
    </div>
    <div className="site-footer__sun-stage" aria-hidden="true"><div className="site-footer__sun"><span /></div><div className="site-footer__large-wordmark">{siteConfig.logo.text}</div></div>
    <div className="site-footer__bottom">
      <p>© {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.</p>
      <p className="site-footer__payments" aria-label="Accepted payment methods">Visa <span>·</span> Mastercard <span>·</span> American Express <span>·</span> PayPal</p>
      <button type="button" onClick={scrollToTop}>Back to top <IoArrowUpOutline aria-hidden="true" /></button>
    </div>
  </footer>;
}

export default Footer;
